import useDisableRubberBandScrolling from '@medflex/hooks/useDisableRubberBandScrolling';
import * as PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import { IconCheckmark, IconClose } from '../Icons';

const PatientInvitationRequests = ({ invitationRequests, onDelete, onInvite, pagesLink }) => {
  const { t } = useTranslation('components');
  return (
    <>
      <header className="flex items-center">
        <h1 className="text-2xl leading-none font-semibold">
          {t('patient_invitation_requests.title')}
        </h1>
      </header>
      <p className="mt-4">
        {t('patient_invitation_requests.description', { allowHtml: true, pagesLink })}
      </p>
      <div className="w-full mt-4 mb-8">
        <div className="mt-4 lg:flex lg:flex-col lg:shadow-lg lg:border">
          <div className="hidden lg:flex py-4 flex-1 uppercase font-semibold text-slate-500 text-sm">
            <div className="w-2/12 ml-4">{t('patient_invitation_requests.date')}</div>
            <div className="w-2/12">{t('patient_invitation_requests.patient')}</div>
            <div className="w-2/12">{t('patient_invitation_requests.date_of_birth')}</div>
            <div>{t('patient_invitation_requests.e-mail')}</div>
          </div>
          {invitationRequests &&
            invitationRequests.map(inv => (
              <div
                key={inv.id}
                className="flex lg:py-4 flex-1 lg:text-sm border-l-4 lg:border-l-none lg:border-0 pl-2 lg:pl-0 my-8 lg:my-0 lg:border-t"
              >
                <div className="flex flex-col lg:flex-row lg:ml-4 lg:w-8/12 mr-4 lg:mr-0 truncate">
                  <div className="flex items-center mt-1 lg:mt-0 lg:w-1/4">{inv.createdAt}</div>
                  <div className="lg:w-1/4 flex items-center truncate">
                    <span className="truncate">{inv.name}</span>
                  </div>
                  <div className="lg:w-1/4 flex items-center">{inv.dateOfBirth}</div>
                  <div className="lg:w-1/4 flex items-center">
                    <span className="truncate">{inv.email}</span>
                  </div>
                </div>
                <div className="flex-grow" />
                <div className="flex items-center">
                  <Button
                    onClick={() => onInvite({ id: inv.id })}
                    className="lg:hidden"
                    shape="square"
                    size="sm"
                  >
                    <IconCheckmark size="4" />
                  </Button>
                  <Button onClick={() => onInvite({ id: inv.id })} className="hidden lg:inline">
                    {t('patient_invitation_requests.invite')}
                  </Button>
                  <button
                    onClick={() => onDelete({ id: inv.id })}
                    type="button"
                    className="text-slate-600 hover:text-slate-500 mx-8 focus:outline-none"
                  >
                    <IconClose size="4" />
                  </button>
                </div>
              </div>
            ))}
          {invitationRequests.length === 0 && (
            <div className="flex-1 flex flex-col items-center justify-center py-16 lg:border-t">
              <div className="italic">{t('patient_invitation_requests.empty_state')}</div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const InvitationRequests = ({
  onInvitePatient,
  patientInvitationRequests,
  onDeletePatientInvitationRequest,
  pagesLink,
  showPatientInvitationRequests,
}) => {
  const divRef = useDisableRubberBandScrolling();

  return (
    <div
      data-component="InvitationRequests"
      className="flex flex-col justify-start flex-1 overflow-y-auto overflow-x-hidden p-2 lg:p-8 mt-8 lg:mt-0"
      ref={divRef}
    >
      {showPatientInvitationRequests && (
        <PatientInvitationRequests
          invitationRequests={patientInvitationRequests}
          onDelete={onDeletePatientInvitationRequest}
          onInvite={onInvitePatient}
          pagesLink={pagesLink}
        />
      )}
    </div>
  );
};

InvitationRequests.defaultProps = {
  onInvitePatient: () => {},
  onDeletePatientInvitationRequest: () => {},
  patientInvitationRequests: [],
};

InvitationRequests.propTypes = {
  onInvitePatient: PropTypes.func,
  onDeletePatientInvitationRequest: PropTypes.func,
  patientInvitationRequests: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      dateOfBirth: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
  ),
  pagesLink: PropTypes.string,
  showPatientInvitationRequests: PropTypes.bool,
};

export default InvitationRequests;
